import { createSlice } from "@reduxjs/toolkit";

const deliciousFilterTypeInitialState = {
  selectedCuisineFilters: ["All"],
  selectedPriceFilters: ["All"],
  selectedRegionFilters: ["All"],
};

export const deliciousFilterTypeReducer = createSlice({
  name: "deliciousFilterType",
  initialState: deliciousFilterTypeInitialState,
  reducers: {
    addCuisineFilterType: (state, action) => {
      if (state.selectedCuisineFilters?.includes(action.payload)) {
        const index = state.selectedCuisineFilters.indexOf(action.payload);
        if (index > -1) {
          // only splice array when item is found
          state.selectedCuisineFilters.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        state.selectedCuisineFilters.push(action.payload);
        if (action.payload === "All") {
          state.selectedCuisineFilters = ["All"];
        }
        if (
          action.payload !== "All" &&
          state.selectedCuisineFilters?.includes("All")
        ) {
          const index = state.selectedCuisineFilters.indexOf("All");
          state.selectedCuisineFilters.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      console.log("selectedCuisineFilters", state.selectedCuisineFilters);
    },

    addPriceFilterType: (state, action) => {
      if (state.selectedPriceFilters?.includes(action.payload)) {
        const index = state.selectedPriceFilters.indexOf(action.payload);
        if (index > -1) {
          // only splice array when item is found
          state.selectedPriceFilters.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        state.selectedPriceFilters.push(action.payload);
      }
      console.log("selectedPriceFilters", state.selectedPriceFilters);
    },

    addRegionFilterType: (state, action) => {
      if (state.selectedRegionFilters?.includes(action.payload)) {
        const index = state.selectedRegionFilters.indexOf(action.payload);
        if (index > -1) {
          // only splice array when item is found
          state.selectedRegionFilters.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        state.selectedRegionFilters.push(action.payload);
        if (action.payload === "All") {
          state.selectedRegionFilters = ["All"];
        }
        if (
          action.payload !== "All" &&
          state.selectedRegionFilters?.includes("All")
        ) {
          const index = state.selectedRegionFilters.indexOf("All");
          state.selectedRegionFilters.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      // console.log("selectedRegionFilters", state.selectedRegionFilters);
    },

    resetFilterTypeState: (state, action) => {
      state.selectedCuisineFilters = ["All"];
      state.selectedPriceFilters = ["All"];
      state.selectedRegionFilters = ["All"];
    },
  },
});

export const {
  addCuisineFilterType,
  resetFilterTypeState,
  addPriceFilterType,
  addRegionFilterType,
} = deliciousFilterTypeReducer.actions;

export default deliciousFilterTypeReducer.reducer;
